import { RiskStatusEnum } from "../../../../../../entities/enums/RiskStatusEnum";

export const RiskStatusHelper = {
  getValue: (riskStatus?: RiskStatusEnum) => riskStatus ?? "Looks good",
};
